import type { AbstractControl, ValidationErrors } from '@angular/forms';

export function operatorPhoneValidator(
	control: AbstractControl,
): ValidationErrors | null {
	const value = typeof control.value === 'string' ? control.value : '';
	let phone = value.trim().replace(/[\s().-]/g, '');
	if (!phone) return null;
	if (phone.startsWith('00')) phone = `+${phone.slice(2)}`;
	if (/^(?:69\d{8}|2\d{9})$/.test(phone)) phone = `+30${phone}`;
	return /^\+[1-9]\d{7,14}$/.test(phone) ? null : { phone: true };
}
